import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

// Schema for PATCH request (all fields optional for partial updates)
const patchOnboardDataSchema = z.object({
  customer_type: z.string().optional(),
  hear_about_us: z.string().optional(),
  total_monthly_sales: z.string().optional(),
  total_monthly_sales_currency: z.string().optional(),
  annual_amazon_sales: z.string().optional(),
});

export type PatchOnboardData = z.infer<typeof patchOnboardDataSchema>;

// Schema for setting onboarding channel
const onboardingChannelValues = ["AMAZON", "WALMART", "SHOPIFY"] as const;
const setOnboardingChannelSchema = z.object({
  channel: z.enum(onboardingChannelValues),
});
const setOnboardingChannelResponseSchema = z.object({
  channel: z.enum(onboardingChannelValues),
});

export const onboardingApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "patchOnboardData",
    method: "patch",
    path: "/onboard_data/",
    status: 200,
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: patchOnboardDataSchema,
      },
    ],
    response: z.unknown(),
  })
    .addEndpoint({
      alias: "setOnboardingChannel",
      method: "post",
      path: "/onboarding/channel/",
      status: 200,
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: setOnboardingChannelSchema,
        },
      ],
      response: setOnboardingChannelResponseSchema,
    })
    .build(),
);
